import createAxiosThunk from 'store/createAxiosThunk';

import { searchTermsUrl as selectSearchTermsUrl } from 'store/fusionServices/selectFusion';
import { type SearchTermResponse, searchTermResponseSchema } from 'schemas';
import { axiosInstance } from '../config/selectAxios';
import { SEARCH_TERMS_SLICE_NAME } from '../slicesNames';

// eslint-disable-next-line import/prefer-default-export
export const fetchSearchTerms = createAxiosThunk<SearchTermResponse, void>(
  `${SEARCH_TERMS_SLICE_NAME}/fetchSearchTerms`,
  async (_args, thunkApi) => {
    const { getState } = thunkApi;

    const state = getState();
    const axios = axiosInstance(state);

    // get search terms url
    const url = selectSearchTermsUrl(state);
    const response = await axios.get<unknown>(url);

    const searchTerms = searchTermResponseSchema.parse(response.data);

    return searchTerms;
  }
);
